import * as Icons from 'lucide-react';
import { RestrictedItemCategory } from '@/types';

interface DynamicIconProps extends Icons.LucideProps {
  name: string;
}

function DynamicIcon({ name, ...props }: DynamicIconProps) {
  const IconComponent = (Icons as any)[name] as Icons.LucideIcon;
  return IconComponent ? <IconComponent {...props} /> : <Icons.AlertTriangle {...props} />;
}

interface CategoryCardProps {
  category: RestrictedItemCategory;
}

export function CategoryCard({ category }: CategoryCardProps) {
  return (
    <div className='rounded-xl border border-sd-border bg-sd-card px-4 py-3.5'>
      {/* Title row */}
      <div className='flex items-center gap-2 mb-2.5'>
        <div className='flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sd-muted border border-sd-border'>
          <DynamicIcon
            name={category.icon}
            className='h-3.5 w-3.5 text-sd-muted-foreground'
            strokeWidth={1.8}
          />
        </div>
        <span className='text-[13px] font-semibold text-sd-foreground leading-snug'>
          {category.title}
        </span>
      </div>

      {/* Items */}
      <div className='flex flex-col gap-[5px] ps-1'>
        {category.items.map((item, i) => (
          <div
            key={i}
            className='flex items-start gap-1.5 text-[12.5px] text-sd-muted-foreground leading-[1.45]'
          >
            <span className='mt-[6px] shrink-0 h-1 w-1 rounded-full bg-sd-muted-foreground/40' />
            <span>{item}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
